import React, { useEffect, useState, Component } from 'react';
interface ObfuscatedEmailProps {
  /** Local part of the address, e.g. "info" */
  user: string;
  /** Domain part of the address, e.g. "iilh.org" */
  domain: string;
  /** Optional className applied to the rendered anchor */
  className?: string;
  /** Optional override for the visible label (defaults to the email itself) */
  label?: string;
  /** Optional mailto subject line */
  subject?: string;
}
/**
 * Renders an email address as a clickable mailto link without ever placing the
 * full address or "mailto:" string in the static markup. The user/domain parts
 * are kept separate and only assembled in the browser after mount, so spam bots
 * that scrape raw HTML never see a harvestable address.
 */
export function ObfuscatedEmail({
  user,
  domain,
  className,
  label,
  subject
}: ObfuscatedEmailProps) {
  const [address, setAddress] = useState('');
  useEffect(() => {
    // Assembled only at runtime — never present as a literal in source/markup.
    setAddress(`${user}\u0040${domain}`);
  }, [user, domain]);
  if (!address) {
    // Pre-hydration / no-JS fallback: show parts a human can read but bots
    // can't easily stitch into a valid address.
    return <span className={className} data-id="element-784" data-mp="2wi4e6n2q3v7b">
        {user} [at] {domain}
      </span>;
  }
  const href = subject ? `mailto:${address}?subject=${encodeURIComponent(subject)}` : `mailto:${address}`;
  return <a href={href} className={className} data-id="element-785" data-mp="35gg04bsna4tf">
      {label ?? address}
    </a>;
}